$(document).ready(function () {
  setFullHeight();
  // changeHeaderSize();

  //when resize device width, calculate again height viewport
  $(window).on("orientationchange resize", setFullHeight);
  //when resize device width, change header size
  $(window).on("orientationchange resize", changeHeaderSize);
  //when scroll change header size
  // $(window).scroll(changeHeaderSize);

  function setFullHeight() {
    document.documentElement.style.setProperty('--vh', `${(window.innerHeight - 39) * 0.01}px`);  
  }

  function changeHeaderSize() {
    // if (
    //   document.body.scrollTop > 10 ||
    //   document.documentElement.scrollTop > 10
    // ) {
    //   $("sticky-header").css("top", 0);
    //   LOGO_WITHOUT_NAME_HEADER();
    // } else {
    //   $("sticky-header").css("top", "39px");
    //   LOGO_WITH_NAME_HEADER();
    // }
  };

  $(".announcement-bar__message .icon-close").on("click", function (e) {
    // The bar can be a link (Enable announcement links): closing must not open it
    e.preventDefault();
    e.stopPropagation();
    $(this).parents(".utility-bar").remove();
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    sessionStorage.setItem('hiddenAnnouncement', "1");
  });

  if(!sessionStorage.getItem('hiddenAnnouncement')){
    $(".utility-bar").css("display", "flex");
    $(".utility-bar").show();
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
  }

  //footer
  const search = new URLSearchParams(window.location.search);
  const formType = search.get('form_type');

  if (formType && formType !== 'contact') {
    $('#ContactFooter-error').show();
  }

  $(".footer-email__field").on( "focus", function() {
    $('.newsletter-hide').css('visibility', 'visible');
    $(".submit__newsletter-form").css("max-height", "500px");
  });

  if ($(window).width() <= 767) {
    $(".section__footer-menu .footer-block__heading").on( "click", function() {
      $(this).parent().find(".footer-block__details-content").toggle();
    });
  }
  
  // hidden newsletter form on activation-success page
  if (window.location.href.includes("/pages/activation-success")) {
    $(".footer-block__newsletter").hide();
  }
});
